import React, { useEffect, useState } from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import styles from '../../components/notice/update/update.module.scss';
import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const NoticeUpdatePage: NextPage = () => {
  const router = useRouter();
  const [startDateTime, setStartDateTime] = useState('');
  const [endDateTime, setEndDateTime] = useState('');

  const isValidDate = (d: any) => {
    return !isNaN(d) && d instanceof Date;
  };

  useEffect(() => {
    if (!router.isReady) return;
    if (!router.query.startDateTime || !router.query.endDateTime) {
      setStartDateTime('2023.11.08 01:00');
      setEndDateTime('2023.11.08 08:00');
      return;
    }

    const startDateTime = new Date(router.query.startDateTime as string);
    const endDateTime = new Date(router.query.endDateTime as string);

    if (!isValidDate(startDateTime) || !isValidDate(endDateTime)) {
      setStartDateTime(DateFormat.format(new Date(), 'yyyy.MM.dd'));
      setEndDateTime('점검 완료 시점까지');
      return;
    }

    setStartDateTime(DateFormat.format(startDateTime, 'yyyy.MM.dd HH:mm'));
    setEndDateTime(DateFormat.format(endDateTime, 'yyyy.MM.dd HH:mm'));
  }, [router.query]);

  return (
    <div className={cx('wrap')}>
      <div className={cx('innner')}>
        <strong className={cx('title')}>잡다 홈페이지 서비스 중단 안내</strong>
        <p className={cx('desc')}>
          서비스 업데이트로 인해 잡다 전체 서비스가 일시적으로 중단됩니다.
          <br />
          이용자 분들의 양해 부탁드립니다.
        </p>

        <ul className={cx('infoList')}>
          <li className={cx('listItem')}>
            <span className={cx('infoTitle')}>작업 내용</span>서비스 업데이트
          </li>
          <li className={cx('listItem')}>
            <span className={cx('infoTitle')}>중단 서비스</span>JOBDA 서비스 전체
          </li>
          <li className={cx('listItem')}>
            <span className={cx('infoTitle')}>중단 일시</span>
            {startDateTime}
            {endDateTime && ` ~ ${endDateTime}`}
          </li>
        </ul>

        <div className={cx('notice')}>* 위의 일정은 작업 상황에 따라 변경될 수 있습니다.</div>
      </div>
    </div>
  );
};

export default NoticeUpdatePage;
